import { FlexBox, Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { Book } from '@fable/types'
import star from 'assets/icons/standard/star-icon-blue.svg'
import { formatRating } from 'components/review_pill/utils'

const SearchbarResultBook = ({ book }: { book: Book }) => {
  const { colors } = useTheme()

  return (
    <FlexBox data-testid="resultBook" alignItems="center">
      <img
        className={css`
          width: 70px;
          height: 105px;
          border-radius: 4px;
        `}
        src={`${book.cover_image_resize}?w=114`}
        alt={book.title}
      />
      <div
        className={css`
          margin-left: 16px;
          text-align: left;
        `}
      >
        <Text
          className={css`
            font-weight: 600;
          `}
          sizing="XS"
          type="subhead"
          text={book.title}
        />
        <Text
          type="body"
          sizing="S"
          text={(book?.authors[0] || [])?.name || ''}
        />
        {!!book.review_average ? (
          <FlexBox
            className={css`
              margin-top: 10px;
            `}
            alignItems="center"
          >
            <img
              src={star}
              alt="star"
              className={css`
                margin-right: 4px;
                width: 12px;
              `}
            />
            <Text
              color={colors.blue}
              type="body"
              sizing="S"
              className={css`
                font-weight: 600;
              `}
              text={`${formatRating(book.review_average)}`}
            />
            &nbsp;{'-'}&nbsp;
            <Text
              color={colors.graphite}
              type="body"
              sizing="S"
              text={`${book.review_count}`}
            />
          </FlexBox>
        ) : null}
      </div>
    </FlexBox>
  )
}

export default SearchbarResultBook
